module.exports = __webpack_public_path__ + "73e48c50eee9e98f09fa009b9d7056d9.png";